import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { AccessInitialization, ActionType, ActiveInactiveFor, AdditionalDetailsWrapper, CommunicationTemplate, ComplaintStatus, DelivererInitialization, DelivererWrapper, GeneralConfigType, InteractionType, KeyValueId, KeyValues10, KeyValues3, KeyValues5, KeyValueSet, KeyValueSetInt, LastUsedKey, LessAlert, LocalService, LoggedMemberWrapper, MemberWrapper, OtpStatusWithId, Paging, Payment, RelationshipInitialization, RelationShipRole, SelectedLocation, Status, StatusWithId, UserInfo, WhiteListStatus, Wrapper10, Wrapper10Initialization, Wrapper15Initialization, Wrappers10, Wrappers15 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})

export class ProfileManagementService {
  private controllerName = service_controllers_methods.profile.controller;
  private methods = service_controllers_methods.profile.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public saveMember(wrapper: MemberWrapper, reference: KeyValueSet = null): Observable<StatusWithId> {
    let body = {
      wrapper: wrapper,
      sel: this.localService.getSelected(),
      refer: reference
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveMember, body);
  }

  public verifyOtp(wrapper: KeyValues5, isForBusiness: boolean): Observable<OtpStatusWithId> {
    wrapper.v1 = isForBusiness ? wrapper.v1 : this.localService.encryptCrypto(wrapper.v1);
    let body = {
      dt: wrapper,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.VerifyOtp, body, true, false, true);
  }

  public sendOtp(wrapper: KeyValues5, additionalData?: KeyValues3): Observable<StatusWithId> {
    let body = {
      dt: wrapper,
      sel: this.localService.getSelected(),
      dtAdditional: additionalData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SendOtp, body);
  }

  public savePwd(strUserId: string, strPwd: string): Observable<StatusWithId> {
    strPwd = this.localService.encryptCrypto(strPwd);
    let selected = this.localService.getSelected();
    selected.v4 = strUserId;

    let body = {
      sel: selected,
      strPwd: strPwd
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePwd, body);
  }

  public getLoggedMember(phoneNumber: string, strPwd: string): Observable<LoggedMemberWrapper> {
    strPwd = strPwd && strPwd.trim() != '' ? this.localService.encryptCrypto(strPwd) : '';
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: phoneNumber, v2: strPwd } as KeyValues3,
      devices: this.localService.getLastDeviceSettings(phoneNumber)
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLoggedMember, body);
  }

  public saveRelationShip(wrapper: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveRelationShip, body);
  }

  public editRelationShip(relatioshipId: string, enumId: string): any {
    let dt = { key: relatioshipId, value: enumId } as KeyValueSet;
    let body = {
      sel: this.localService.getSelected(),
      dt: dt
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.EditRelationShip, body);
  }

  public getRelationshipInitialization(strBusinessId): Observable<RelationshipInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strBusinessId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetRelationshipInitialization, body);
  }

  public getRelationships(strBusinessId: string, isShowDeletedItems: boolean, strSelectedRole: string, paging: Paging): Observable<Wrappers10> {
    let dt = { key: strBusinessId, v1: isShowDeletedItems ? "1" : "0", v2: strSelectedRole } as KeyValues3;
    let body = {
      sel: this.localService.getSelected(),
      dt: dt,
      pag: paging,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetRelationships, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public saveCredits(relatioshipId: string, amount: any, isAddCredits: boolean, creditType: any, notes: string, forId: string): Observable<StatusWithId> {
    let dt = { key: relatioshipId, v1: amount, v2: isAddCredits ? "1" : "0", v3: creditType, v4: notes, v5: forId } as KeyValues5;
    let body = {
      sel: this.localService.getSelected(),
      dt: dt
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCredits, body);
  }

  public getUserInitialization(): Observable<Wrapper10Initialization> {
    let body = {
      sel: this.localService.getSelected(),
      pag: this.localService.getLastPagingSetup(GeneralConfigType.PagingMembers),
      selD: this.localService.getLastPagingSetupAdditionalFilter(GeneralConfigType.PagingMembers)
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUserInitialization, body);
  }

  public getMembers(paging: Paging, isArchive: boolean): Observable<Wrappers10> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingMembers);

    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: isArchive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMembers, body, paging != null && !paging.isAutoRefresh);
  }

  public getPaymentInitialization(paymentStage: any, forId: string): Observable<Wrapper15Initialization> {

    let paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingPayments);
    let dt = {
      key: forId,
      v1: paymentStage,
      v5: ''
    } as KeyValues5;
    let body = {
      sel: this.localService.getSelected(),
      dt: dt,
      selL: null,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentInitialization, body);
  }

  public getMyPayments(paymentStage: any, forId: string, ctryCode: string, selectedLocation: any, paging: Paging): Observable<Wrappers15> {

    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingPayments);
    let dt = {
      key: forId,
      v1: paymentStage,
      v5: ctryCode
    } as KeyValues5;
    let body = {
      sel: this.localService.getSelected(),
      dt: dt,
      selL: selectedLocation,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMyPayments, body);
  }

  public saveLastUsedSetting(item: LastUsedKey) {
    var items: LastUsedKey[] = [];
    items.push(item);
    return this.saveLastUsedSettings(items);
  }

  public saveLastUsedSettings(items: LastUsedKey[], businessId?: string): Observable<StatusWithId> {
    if (!this.localService.lastUsedSettings) {
      this.localService.lastUsedSettings = [];
    }

    items.forEach(item => {
      var itemTemp = businessId ?
        this.localService.lastUsedSettings.find(x => x.userOrBusinessId == businessId && x.keyType == item.keyType && x.inteactionType == InteractionType.Business)
        : this.localService.lastUsedSettings.find(x => x.keyType == item.keyType && x.inteactionType == InteractionType.User);
      if (itemTemp) {
        itemTemp.value = item.value;
      } else {
        if (businessId)
          this.localService.lastUsedSettings.push(item);
        else
          this.localService.lastUsedSettings.push(item);
      }
    });
    const body = {
      sel: this.localService.getSelected(),
      selD: items,
      dt: { v1: businessId ?? '' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLastUsedSettings, body, null);
  }

  public getLastUsedSettings(): Observable<LastUsedKey[]> {
    let dt = this.localService.getLastUser();
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: dt.key, v2: dt.value } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLastUsedSettings, body);
  }

  public savePayment(lstItems: string[], isWaiver: boolean, strComment: string, receiptCountryCode: string, payment: Payment = null): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: isWaiver ? 1 : 0, value: strComment } as KeyValueSetInt,
      items: lstItems,
      ctry: receiptCountryCode,
      py: payment
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePayment, body);
  }

  public saveServiceProvider(wrapper: Wrapper10, lstNotifications: string[], address: KeyValues3[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper,
      address: address,
      dt: lstNotifications
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveServiceProvider, body);
  }

  public getDelivererInitialization(): Observable<DelivererInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      pag: this.localService.getLastPagingSetup(GeneralConfigType.PagingDeliverer),
      selL: null
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDelivererInitialization, body);
  }

  public getDeliverer(id: string, ctryCode: string): Observable<DelivererWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      id: id,
      ctry: ctryCode
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDeliverer, body);
  }

  public getEmptyDeliverer(): Observable<DelivererWrapper> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetEmptyDeliverer, body);
  }

  public getMyDeliverer(id: string = '', ctryCode: string = ''): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      id: id,
      ctry: ctryCode
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMyDeliverer, body);
  }

  public toggleDeliver(id: string, index: number): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      id: id,
      idx: index
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ToggleDeliver, body);
  }

  public getDeliverers(paging: Paging, selectedLocation: KeyValues5): Observable<Wrappers10> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingMembers);

    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      selL: selectedLocation
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDeliverers, body, paging != null && !paging.isAutoRefresh);
  }

  public getPinnedDeliverers(): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPinnedDeliverers, body);
  }

  public savePinnedDeliverers(delivererId: string, isUnpin: boolean): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      id: delivererId,
      unpin: isUnpin ? "1" : "0"
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePinnedDeliverers, body);
  }

  public getInvoice(invoiceId: string, countryCode: string, isExternal: boolean): Observable<KeyValueSet> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: invoiceId, v1: countryCode, v2: isExternal ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetInvoice, body);
  }

  public getUserInfo(userId: string, countryCode: string): Observable<UserInfo> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: userId, v1: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUserInfo, body);
  }

  public editSystemInfo(userId: string, countryCode: string): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: userId, v1: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.EditSystemInfo, body);
  }

  public saveSystemInfo(userId: string, countryCode: string, data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: userId, v1: countryCode } as KeyValues3,
      wrapper: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveSystemInfo, body);
  }

  public editAdditionalDetails(userId: string, countryCode: string): Observable<AdditionalDetailsWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: userId, v1: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.EditAdditionalDetails, body);
  }

  public saveAdditionalDetails(userId: string, countryCode: string, data: AdditionalDetailsWrapper): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: userId, v1: countryCode } as KeyValues3,
      wrapper: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveAdditionalDetails, body);
  }

  public onAction(id: string, countryCode: string, actionType: ActionType): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: id, v1: countryCode } as KeyValues3,
      at: actionType
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.OnAction, body);
  }

  public saveUserAccess(data: any): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveUserAccess, body);
  }

  public getAccessInitialization(userId: string, countryCode: string): Observable<AccessInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dtC: { key: userId, v1: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAccessInitialization, body);
  }

  public getUserAccess(userId: string, countryCode: string): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dtC: { key: userId, v1: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUserAccess, body);
  }

  public getBrnDetails(iBrn, strBusinessId: string, isContactNumber: boolean, relationShipType: InteractionType, relationShipRole: RelationShipRole): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: iBrn, v2: strBusinessId, v3: isContactNumber ? '1' : '0', v4: relationShipType.toString(), v5: relationShipRole.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBrnDetails, body);
  }

  public getBrnDetailsByQr(iBrn, strBusinessId: string, isCustomerAsBusiness: boolean, relationShipType: InteractionType, relationShipRole: RelationShipRole): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: iBrn, v2: strBusinessId, v3: isCustomerAsBusiness ? '1' : '0', v4: relationShipType.toString(), v5: relationShipRole.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBrnDetailsByQr, body);
  }

  public getBrnDetailsByUser(iBrn, strBusinessId: string, relationShipType: InteractionType, relationShipRole: RelationShipRole): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: iBrn, v2: strBusinessId, v3: relationShipType.toString(), v4: relationShipRole.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBrnDetailsByUser, body);
  }

  public getDeliveryAddresses(userId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: userId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDeliveryAddresses, body);
  }

  public saveDeliveryAddess(deliveryAddress: KeyValues3): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: deliveryAddress,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveDeliveryAddess, body);
  }

  public getDeliveryAddress(strId: string): Observable<KeyValueSet> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDeliveryAddress, body);
  }

  public addWhiteList(data: KeyValues3, strRequestorCtryCode: string): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(strRequestorCtryCode),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.AddWhiteList, body);
  }

  public getWhiteLists(strRequestorCtryCode: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(strRequestorCtryCode)
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetWhiteLists, body);
  }

  public updateStatus(strId: string, whiteListStatus: WhiteListStatus, strRequestorCtryCode: string, strComment): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(strRequestorCtryCode),
      dt: { key: strId, v1: whiteListStatus.toString(), v2: strComment } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateStatus, body);
  }

  public getWhitelist(strId: string, strRequestorCtryCode: string): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(strRequestorCtryCode),
      dt: { key: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetWhitelist, body);
  }

  public getMember(strId: string): Observable<MemberWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMember, body);
  }

  public isAllowedForItem(strId: string, strtBusinessId: string = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: this.localService.currentPageKey.toString(), v1: strId, v2: strtBusinessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.IsAllowedForItem, body);
  }

  public getCreditlogs(strId: string, paging: Paging): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCreditlogs, body);
  }

  public getLessAlert(isShowSpinner = false): Observable<LessAlert> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLessAlert, body, isShowSpinner);
  }

  public newComplaint(data: KeyValues3): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.NewComplaint, body);
  }

  public newComplaintDetail(data: KeyValues3): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.NewComplaintDetail, body);
  }

  public getComplaintsInitialization(isForCustomer: boolean, complaintStatus: string, isShowOnlyOwnLoginAssigned: boolean): Observable<Wrapper10Initialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isForCustomer ? '1' : '0', v2: complaintStatus ?? '0', v3: isShowOnlyOwnLoginAssigned ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetComplaintsInitialization, body);
  }

  public getComplaints(isForCustomer: boolean, paging: Paging, selectedData: KeyValues5, complaintStatus: string, isShowOnlyOwnLoginAssigned: boolean): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isForCustomer ? '1' : '0', v2: complaintStatus ?? '0', v3: isShowOnlyOwnLoginAssigned ? '1' : '0' } as KeyValues3,
      pag: paging,
      selD: selectedData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetComplaints, body);
  }

  public getComplaintDetails(strId: string, countryCode: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId, v2: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetComplaintDetails, body);
  }

  public getComplaintStatus(strId: string, countryCode: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId, v2: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetComplaintStatus, body);
  }

  public updateComplaintStatus(strId: string, countryCode: string, complaintStatus: ComplaintStatus): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strId, v1: complaintStatus.toString(), v2: countryCode } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateComplaintStatus, body);
  }

  public getWorkingAsDetail(strCtryCode: string, strUserId: string, strBusinessId: string, strBusinessIdAsCustomer: string): Observable<KeyValues10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strCtryCode, v1: strUserId, v2: strBusinessId, v3: strBusinessIdAsCustomer } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetWorkingAsDetail, body);
  }

  public getAssociatedAccounts(strCtryCode: string, strUserOrBusinessId: string, isUser: boolean): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strCtryCode, v1: strUserOrBusinessId, v2: isUser ? "1" : "0" } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAssociatedAccounts, body);
  }

  public blockUnblockAccounts(strCtryCode: string, items: KeyValues3[], isUser: boolean): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strCtryCode, v1: isUser ? "0" : "1" } as KeyValues3,
      dtC: items
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.BlockUnblockAccounts, body);
  }

  public getPendingPayment(): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPendingPayment, body);
  }

  public getReference(paging: Paging): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReference, body);
  }

  public getMemberName(strCountryCode: string, strUserId: string, isShowSpinner = true): Observable<KeyValueSet> {
    let body = {
      dt: { v1: strCountryCode, v2: strUserId, v3: this.localService.selected.applicationLanguage } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMemberName, body, isShowSpinner);
  }

  public getUpi(strCountryCode: string, strUserOrBusinessId: string, interactionType: InteractionType): Observable<StatusWithId> {
    let body = {
      dt: { v1: strCountryCode, v2: strUserOrBusinessId, v3: interactionType.toString() } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetUpi, body);
  }

  public resetCurrentToken(strCountryCode: string, strUserId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strCountryCode, v2: strUserId, v3: this.localService.selected.applicationLanguage } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ResetCurrentToken, body);
  }

  public getRentReceiptLogs(ctryCode: string, interactionType: InteractionType, countryId: string, stateId: string, districtId: string, constituencyId: string, timeStamp: string, paging: Paging): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      selL: {
        CountryCode: ctryCode,
        CountryId: countryId && countryId != '0' ? countryId : undefined,
        StateId: stateId && stateId != '0' ? stateId : undefined,
        DistrictId: districtId && districtId != '0' ? districtId : undefined,
        ConstituencyId: constituencyId && constituencyId != '0' ? constituencyId : undefined
      } as SelectedLocation,
      pag: paging,
      dt: { v1: interactionType.toString(), v2: timeStamp && timeStamp != '0' ? timeStamp : '' } as KeyValues5,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetRentReceiptLogs, body);
  }

  public getDefautContactNumbersToSend(communicationTemplate: CommunicationTemplate, key: string): Observable<string[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: communicationTemplate.toString(), v2: key } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDefautContactNumbersToSend, body);
  }

  public sendMessageToPhone(communicationTemplate: CommunicationTemplate, key: string, contactNumbers: string[], printingLanguage: string, printerTemplateIds: string[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: communicationTemplate.toString(), v2: key, v3: printingLanguage } as KeyValues5,
      ids: printerTemplateIds,
      dt1: contactNumbers
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SendMessageToPhone, body);
  }

  public updateDeliveryAddress(key: string, title: string, address: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: key, v1: title, v2: address } as KeyValues3,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateDeliveryAddress, body);
  }
}
